export default __webpack_public_path__ + "assets/images/cbdc35a426b1ee511609454581b63922.jpeg";